import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[grecoFormContainer]' })
export class AddCouponAssignmentFormContainerDirective {
  constructor(public readonly viewRef: ViewContainerRef) {}
}
